import { Typography } from '@mui/material';

interface PageTitleProps {
  title: string;
}

export function StyledPageTitle({ title }: PageTitleProps) {
  return (
    <Typography sx={{ textTransform: 'uppercase' }} variant="h1">
      {title}
    </Typography>
  );
}
